import React, { useState, useEffect } from 'react';
import { translate } from 'react-i18next';
import {
  KeyCode,
  MAX_CHARS_IN_REVIEW_SECTION,
} from '../../../../../utils/constants';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import { Text, TextButton } from 'wix-style-react';
import s from './ReviewItem.scss';

function ReviewDetails({
  t,
  reviewInModal,
  review,
  servicesLegacyMap,
  descriptionMargin,
}) {
  const { description } = review.reviewData.review;
  const {
    serviceType,
    serviceInnerType,
    url,
  } = review.completedData.statusData;
  const [showMore, setShowMore] = useState(false);
  const [shortDescription, setShortDescription] = useState('');

  useEffect(() => {
    if (description.length > MAX_CHARS_IN_REVIEW_SECTION) {
      const shortDescription = `${description.substr(
        0,
        MAX_CHARS_IN_REVIEW_SECTION,
      )}...`;
      setShowMore(false);
      setShortDescription(shortDescription);
    } else {
      setShowMore(true);
    }
  }, [description]);

  function renderUrl() {
    if (serviceType === 5 && serviceInnerType === 6) {
      return t('client-expertview-reviews-view-now');
    }
    return url;
  }
  return (
    <>
      {!reviewInModal && !showMore && (
        <Text
          weight="thin"
          size="small"
          secondary={false}
          light={false}
          tagName="div"
          className={s.reviewDescription}
          style={{ margin: descriptionMargin }}
        >
          {shortDescription}
          <span>
            &nbsp;
            <a
              className={s.toggleReadMore}
              onClick={() => {
                setShowMore(true);
              }}
              onKeyUp={e => {
                e.keyCode === KeyCode.Enter && e.target.click();
              }}
              data-hook="review-item-read-more"
            >
              <TextButton as="span" size="small" suffixIcon={<ChevronRight />}>
                {t('client-expertview-reviews-read')}
              </TextButton>
            </a>
          </span>
        </Text>
      )}
      {(reviewInModal || showMore) && (
        <Text
          weight="thin"
          size="small"
          secondary={false}
          light={false}
          tagName="div"
          className={s.reviewDescription}
          style={{ margin: descriptionMargin }}
        >
          {description}
        </Text>
      )}
      <Text
        weight="thin"
        size="small"
        secondary={false}
        light={false}
        tagName="div"
        className={s.reviewCompletedData}
      >
        {t(
          `client-exploreservices-${
            servicesLegacyMap[
              `legacyServiceId${serviceType}legacyTypeId${serviceInnerType}`
            ]
          }-label`,
        )}
        {': '}
        <a className={s.reviewCompletedUrl} href={url} target="_blank">
          <TextButton
            as="span"
            size="small"
            tabIndex={-1}
            dataHook="review-link-text-button"
          >
            {renderUrl()}
          </TextButton>
        </a>
      </Text>
    </>
  );
}

export default translate()(ReviewDetails);
